"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var base_1 = require("@bhtp-client-api/base");
var PackageDetailsViewModel = (function (_super) {
    __extends(PackageDetailsViewModel, _super);
    function PackageDetailsViewModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PackageDetailsViewModel;
}(base_1.ApiPackage));
exports.PackageDetailsViewModel = PackageDetailsViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/package-details-view.model.js